import React from 'react';
import '../../css/vers2/IllnessSection.css';

type IllnessSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const IllnessSection = ({ setPage }: IllnessSectionProps) => {
    return (
        <section id="ziekte" className="illness-new-section page-section">
            <img className="illness-icon title-icons title-icons-pink-left" src="/icons/ilness/titleIcons.png" alt="" />
            <img className="illness-icon title-icons title-icons-pink-mid" src="/icons/ilness/titleIcons.png" alt="" />
            <img className="illness-icon title-icons title-icons-yellow3" src="/icons/ilness/titleIcons.png" alt="" />

            <img className="illness-icon right-up-child up-child-body" src="/icons/ilness/rightUpChild.png" alt="" />
            <img className="illness-icon right-up-child up-child-drops" src="/icons/ilness/rightUpChild.png" alt="" />
            <img className="illness-icon right-up-child up-child-stars" src="/icons/ilness/rightUpChild.png" alt="" />

            <img className="illness-icon right-down-child down-child-body" src="/icons/ilness/rightDownChild.png" alt="" />
            <img className="illness-icon right-down-child down-child-drops" src="/icons/ilness/rightDownChild.png" alt="" />

            <h2 className="illness-title">
                <span className="illness-title-word">Ziekte</span>{' '}
                <span className="illness-title-word">en</span>{' '}
                <span className="illness-title-word">vakantie</span>
            </h2>

            <div className="illness-text">
                <p>Bij afwezigheid/vakantie van het kind worden de contacturen 100% doorberekend.</p>
                <p>Is uw kind ziek? Neem dan zo snel mogelijk contact op voor overleg.</p>
                <p>Als uw kind koorts heeft (38 graden) tijdens de opvang wordt er met u contact opgenomen.</p>
                <p>
                    Als uw kind zich niet lekker voelt en er een hulp van een huisarts wordt ingeschakeld
                    of er is besmettingsgevaar, dient u uw kind op te halen.
                </p>
                <p>Vakanties dient u 1 maand van tevoren door te geven.</p>
                <p>
                    Komt uw kind een geplande dag niet, dient u dit uiterlijk 1 dag van tevoren door te geven.
                    De kosten worden wel doorberekend.
                </p>
                <p>
                    Als uw kind een besmettelijke ziekte heeft, hoor ik dit graag van u. Het is van belang
                    dat u mij op de hoogte stelt, zodat ik andere ouders kan inlichten over mogelijk besmettingsgevaar.
                </p>
                <p>
                    Gastouder: Als de gastouder ziek is en de opvang niet door kan gaan, zal de gastouder dit
                    zo snel mogelijk aan u doorgeven.
                </p>
            </div>
        </section>
    );
};

export default IllnessSection;
